import styled, { createGlobalStyle } from "styled-components"

export const StyledPortionFormItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  border-radius: 8px;
  background-color: #fff;
`

export const PortionLabel = styled.div`
  font-size: 16px;
`
